import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right-circle",
  "use": "arrow-right-circle-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"arrow-right-circle\"><path d=\"M0 256c0 141 115 256 256 256s256-115 256-256S397 0 256 0 0 115 0 256zm419 0L256 397V291H99v-70h157V115z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right-circle.svg
// module id = 192
// module chunks = 0